<!-- 财富号信息 -->
<template>
  <div class="cfh-box" v-if="!$isEmpty(wealthInfo.wealthName) || !$isEmpty(listInfo.length)">
    <!-- 机构财富号 -->
    <div class="row">
      <span class="wealth-name">{{wealthName}}</span>
      <div class="more row" @click="goWealthHome">
        <div v-if="!$isEmpty(wealthInfo.labelName)" class="label-name"
          >{{wealthInfo.labelName}}</div>
        <div v-else class="default-label">机构主页</div>
        <img :src="arrow" class="arrow" />
      </div>
    </div>
    <!-- 解读&广告列表 -->
    <div v-for="(item, index) in listInfo" :key="index" class="row info-row" @click="goDetail">
      <div class="info-content">
        <div :style="getItemStyle(item)" class="tag">{{item.tag}}</div>
        <div class="title">{{item.content}}</div>
      </div>
      <div class="date">{{item.date}}</div>
    </div>
  </div>
</template>

<script>
import tool from '../../utils/tool';

export default {

  name: 'cfh-info',

  props: {
    fundCode: {
      type: String,
      default: () => '',
    },
    cfhInfo: {
      type: Object,
      default: () => ({}),
    },
    pageConfig: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      arrow: 'https://j5.dfcfw.com/sc/image/202305/20230529052234.png',
    };
  },

  computed: {
    wealthInfo() { // 财富号机构信息
      return this.cfhInfo.wealthInfo || {};
    },
    listInfo() {
      const readInfo = this.cfhInfo?.readInfo || [];
      const configInfo = this.pageConfig?.advertisementConfig || [];
      // 配置广告数据需要过滤
      const temp = configInfo.filter((item) => item?.excludeCodes.indexOf(this.fundCode) < 0
          || item?.includeCodes.indexOf(this.fundCode) >= 0);
      return [...readInfo, ...temp];
    },
    wealthName() { // 机构名
      return this.$isEmpty(this.wealthInfo.wealthName) ? '财富号'
        : `${this.wealthInfo.wealthName}财富号`;
    },
  },

  methods: {
    goDetail() {
      this.$wxSendTrack('wxpzy.tb.cfhzx.click', 'Click', { infoCode: this.fundCode, infoCodeType: 5 });
      this.$goFundApp();
    },
    goWealthHome() {
      this.$wxSendTrack('wxpzy.tb.cfh.click', 'Click', { infoCode: this.fundCode, infoCodeType: 5 });
      this.$goFundApp();
    },
    getItemStyle(item) {
      return {
        color: item.tagColor,
        backgroundColor: tool.hexToRgba(item.tagColor, 0.1),
      };
    },
  },

};
</script>

<style lang="less" scoped>
.cfh-box {
  width: 100%;
  padding: 32px 24px 32px 32px;
  background-color: #FFFFFF;
  border-radius: 12px;
  box-sizing: border-box;
  margin-bottom: 24px;
}
.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.wealth-name {
  flex: 1;
  font-size: 30px;
  color: #000000;
  line-height: 30px;
  font-weight: 700;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
}
.more {
  margin-left: 12px;
  height: 32px;
}
.label-name {
  color: #FA5914;
  padding: 4px 9px 4px 9px;
  background: rgba(255, 100, 52,0.1);
  border-radius: 4px;
  font-size: 20px;
  text-align: center;
}
.default-label {
  font-size: 28px;
  color: #666666;
}
.arrow {
  height: 32px;
  right: 32px;
  margin-left: 8px;
}
.info-row {
  margin-top: 32px;
}
.info-content {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
}
.tag {
  border-radius: 4px;
  font-size: 20px;
  text-align: center;
  padding: 4px 8px;
}
.title {
  margin-left: 12px;
  font-size: 32px;
  color: #000000;
  flex: 1;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
}
.date {
  font-size: 24px;
  color: #999999;
}
</style>
